export default __webpack_public_path__ + "static/media/7.4706851c.svg";